import { createBrowserRouter,RouterProvider } from "react-router-dom";
import Navbar from "./componets/Navbar/Navbar";
import Main from "./componets/Main/Main";
import BulletPoints from "./componets/BulletPoints/BulletPoints";

function App() {

  const browserRouter = createBrowserRouter([
    {
      path:"/",
      element:<Navbar />,
      children:[
        {
          path:"/",
          element:<Main />
        },
        {
          path:"/slides",
          element:<BulletPoints />
        },
      ]
    }
  ])
  return (
    <div>
      <RouterProvider router={browserRouter}/>
    </div>
  );
}

export default App;
